import type { SessionCard } from "../session/types";
import { useUiText } from "../i18n/useUiText";
import { SparkIcon } from "./Icons";

interface CardTileProps {
  readonly card: SessionCard;
  readonly selected: boolean;
  readonly covered?: boolean;
  readonly ghosted?: boolean;
  readonly onSelect: (element: HTMLButtonElement) => void;
}

export function CardFaceContent({ card }: { readonly card: SessionCard }) {
  const t = useUiText();
  const isDual = card.cardKind === "DUAL";

  return (
    <span className="card-face__content">
      <span className="card-face__meta">
        <span className={`card-kind${isDual ? " card-kind--dual" : ""}`}>
          {isDual ? <SparkIcon /> : null}
          {isDual ? t("card.dual") : t("card.normal")}
        </span>
      </span>
      <span className="card-face__word">{card.displayText}</span>
      <span className="card-face__mark" aria-hidden="true" />
    </span>
  );
}

export function CardTile({
  card,
  selected,
  covered = false,
  ghosted = false,
  onSelect
}: CardTileProps) {
  const t = useUiText();
  const isDual = card.cardKind === "DUAL";

  const classes = [
    "card-tile",
    selected && !covered ? "card-tile--selected" : "",
    isDual ? "card-tile--dual" : "",
    covered ? "card-tile--covered" : "",
    ghosted ? "card-tile--ghosted" : ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      aria-label={covered ? t("hand.cover") : card.displayText}
      aria-pressed={selected && !covered}
      className={classes}
      data-card-id={card.cardId}
      onClick={(event) => {
        event.stopPropagation();
        onSelect(event.currentTarget);
      }}
      type="button"
    >
      <span className="card-tile__inner">
        <span className="card-tile__front card-face">
          <CardFaceContent card={card} />
        </span>
        <span className="card-tile__back" aria-hidden="true">
          <span className="card-back__mark">You Said It!</span>
        </span>
      </span>
    </button>
  );
}
